import { createColumnHelper, FilterFn, Row } from '@tanstack/react-table';
import { FiberManualRecord } from '@mui/icons-material';
import i18n from '../../../../global/config/i18n';
import { DataGrid } from '../../../../global/components';
import { LightColor as Color } from 'theme/constants';
import { LightColor, TerminalContainer } from 'modules/global/adapters/crpAPI';

const greenLightValueStyle = { display: 'flex', alignItems: 'center' };

const showIcon = (color: LightColor | undefined) => {
  switch (color) {
    case Color.Grey:
      return <FiberManualRecord fontSize="medium" htmlColor={'#808080'} />;
    case Color.Yellow:
      return <FiberManualRecord fontSize="medium" htmlColor={'#dfc920'} />;
    case Color.Orange:
      return <FiberManualRecord fontSize="medium" htmlColor={'#f57b00'} />;
    case Color.Red:
      return <FiberManualRecord fontSize="medium" htmlColor={'#e60000'} />;
    case Color.Green:
      return <FiberManualRecord fontSize="medium" htmlColor={'#4AB55F'} />;

    case undefined:
    default:
      return <FiberManualRecord fontSize="medium" htmlColor={'#808080'} />;
  }
};

const columnHelper = createColumnHelper<TerminalContainer>();

const arrayFilter: FilterFn<TerminalContainer> = (
  row: Row<TerminalContainer>,
  columnId: string,
  filterValue: string
) => {
  const values: string[] = row.getValue(columnId);

  return values.some((value) => value.toLowerCase().includes(filterValue.toLowerCase()));
};

const baseTerminalLineColumns = [
  columnHelper.accessor('equipmentNumber', {
    cell: (info) => info.getValue(),
    size: 250,
    header: () => i18n.t('glossary:containerNumber'),
    filterFn: 'includesString',
  }),
  columnHelper.accessor('billOfLadingNumbers', {
    cell: (info) => info.getValue(),
    header: () => i18n.t('glossary:billOfLadingNumbers'),
    filterFn: arrayFilter,
  }),
  columnHelper.accessor('shippingAgentName', {
    cell: (info) => info.getValue(),
    header: () => i18n.t('glossary:shippingAgentName'),
    filterFn: 'includesString',
  }),
  columnHelper.accessor('terminalOperationValue', {
    cell: ({ row, getValue }) => (
      <div style={greenLightValueStyle}>
        {showIcon(row.original.terminalOperationColor)} {getValue<string>()}
      </div>
    ),
    header: () => i18n.t('glossary:terminalOperationValue'),
    enableColumnFilter: false,
  }),
  columnHelper.accessor('terminalReadyValue', {
    cell: ({ row, getValue }) => (
      <div style={greenLightValueStyle}>
        {showIcon(row.original.terminalReadyColor)} {getValue<string>()}
      </div>
    ),
    header: () => i18n.t('glossary:terminalReadyValue'),
    enableColumnFilter: false,
  }),
  columnHelper.accessor('customsValue', {
    cell: ({ row, getValue }) => (
      <div style={greenLightValueStyle}>
        {showIcon(row.original.customsColor)} {getValue<string>()}
      </div>
    ),
    header: () => i18n.t('glossary:customsValue'),
    enableColumnFilter: false,
  }),
];

export const baseTerminalColumnsWithCheckbox = [
  columnHelper.display({
    id: 'actions',
    cell: (cellProps) => <DataGrid.CheckboxRow {...cellProps} />,
    header: (headerProps) => <DataGrid.CheckboxHeader {...headerProps} />,
    size: 60,
    enableResizing: false,
  }),
  ...baseTerminalLineColumns,
];
